import * as React from 'react';
import styled from 'styled-components';//emotion:chakuraUI(型付与)
import { useNavigate } from 'react-router-dom';

import { IconButton ,Button} from '@chakra-ui/react';
import { PhoneIcon, AddIcon, WarningIcon ,SearchIcon ,ArrowLeftIcon} from '@chakra-ui/icons';

import { useTranslation } from 'react-i18next';


type Props = {

}
export const CloseButtonChakra: React.FC<Props> = (props) => {
  const nav = useNavigate();
  const [t, i18n] = useTranslation();
  return (
    <Button
      onClick={()=>nav(-1)}
      borderRadius={'10px'}
      backgroundColor={'white'}
      color={'orange.300'}
      w={'70px'}
      id={`btn-default-backup-back`}
    >
    {t('戻る')}
   </Button>
  );
};